import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { CASES, BRANDS_ALL } from "@/data/content";

export default function Work() {
  return (
    <div data-testid="work-page">
      <PageHeader
        kicker="Selected work"
        title='Creator <span class="text-warm-600">businesses</span>, built.'
        intro="A selection of the creator engagements that defined the firm — talent careers, retail collaborations, scripted production, books and IP across fifteen years of the creator economy."
      />

      <section className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14 pb-24">
        {CASES.map((c, i) => (
          <Reveal key={c.slug}>
            <article
              data-testid={`case-${c.slug}`}
              className="case-block grid md:grid-cols-12 gap-8 md:gap-12 items-center border-t border-line py-16 md:py-28 first:border-t-0"
            >
              <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <div className="relative aspect-[5/4] overflow-hidden bg-mute">
                  <img
                    src={c.image}
                    alt={c.imageAlt}
                    referrerPolicy="no-referrer"
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-1 md:pr-8" : "md:pl-4"}`}>
                <div className="eyebrow mb-4">Case — {String(i + 1).padStart(2, "0")} · {c.role}</div>
                <h3 className="display text-ink" style={{ fontSize: "clamp(36px, 4.5vw, 72px)" }}>
                  {c.title}
                </h3>
                <div className="mt-2 text-warm-600 text-sm">{c.period}</div>
                <p className="mt-6 text-ink-800 leading-relaxed text-base md:text-lg">{c.summary}</p>

                <div className="mt-10 grid grid-cols-3 gap-px bg-line border border-line">
                  {c.metrics.map((m, mi) => (
                    <div key={mi} className="bg-paper p-4 md:p-6">
                      <div className="display text-ink text-xl md:text-2xl leading-tight" style={{ letterSpacing: "-0.02em" }}>{m.v}</div>
                      <div className="eyebrow text-warm-600 mt-2" style={{ fontSize: "10px" }}>{m.l}</div>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </section>

      {/* Brand partners — restrained text wall */}
      <section className="border-t border-line py-24 md:py-32 bg-mute">
        <div className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14">
          <Reveal>
            <div className="eyebrow mb-6">Brand partners</div>
            <h2 className="display text-ink mb-12" style={{ fontSize: "clamp(36px, 5vw, 72px)" }}>
              Worked with.
            </h2>
          </Reveal>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-px bg-line border border-line">
            {BRANDS_ALL.map((b) => (
              <div key={b} className="bg-paper py-10 px-6 flex items-center justify-center hover:bg-mute transition-colors">
                <span className="display text-ink text-xl md:text-2xl">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
